const theme = {
	text: {
		colors: {
			primary: '#4D4F5C',
		},
	},
	checkbox: {
		colors: {
			primary: '#707070',
		},
	},

	colors: {
		primary: '#0885D5',
		secondary: '#fbfbfb',
		validation: '#04BF2A',
		warning: '#FFC13D',
		error: '#FF4E4E',
		grey: '#00000080',
		errorlight: '#F5D7D7',
		info: '#C2DFF2',
		white: '#FFFFFF',
		black: '#000000',
		eraser: '#A1A1A1',
		tabText: '#4D4F5C',
		toastText: '#00A822',
		hoverValidation: '#00A822' /* '#06E333' */,
		hoverError: '#EB3535' /* '#FF8080' */,
		hoverPrimary: '#046CAE' /* '#25A0EF' */,
		hoverGrey: '#515151' /* '#AEAEAE' */,
		backgroundScroll: '#EBEBEB',
		greenFluo: '#00FF33',
		blackArticleLife: '#242424',
		datePickerBg: '#f0f0f0',
		menu: {
			wrapper: '#323232',
			link: '#4B4D52',
		},
		cancel: '#8D9097',
		TabNav: {
			border: '#E5E5E5',
		},
		whiteGrey: '#EEEEEE',
		table: {
			header: {
				main: '#F5F6FA',
				secondary: '#D6EFFF',
				text: '#A3A6B4',
			},
			body: {
				text: '#4D4F5C',
			},
			borderTable: '#F1F1F3',
			line: '#FFFFFF',
			nested: {
				header: '#949494',
			},
		},
		form: {
			reload: '#727272',
			reset: '#A1A1A1',
			validate: '#04BF2A',
		},
		userSettingSlider: '#ccc',
		buttons: {
			dark: '#046CAE',
		},
		wedealBlueOther: '#0979C1',
		wedealRedOther: '#FF8080',
		dropdownDefault: '#E5E5E5',
		listNav: {
			border: '#E5E5E5',
			hover: '#046CAE',
		},
		datePicker: {
			borderInput: '#E5E5E5',
		},
		menuNested: {
			bcg: '#191919',
		},
		scrollBar: {
			scrollBarBG: 'rgba(0,0,0,.15)',
			scrollBarThumbBG: '#4D4F5C',
			scrollBarThumbBGActive: 'rgba(77, 79, 92, 0.7)',
			scrollBarGrey: '#E5E5E5',
		},
		input: {
			border: '#E5E5E5',
		},
		progressBar: {
			border: '#4D4F5C',
			colors: {
				red: '#EF4E37',
				orange: '#F68239',
				lightOrange: '#FA9C3B',
				yellow: '#FFBE3D',
				lightCamo: '#C6BB37',
				camo: '#86B530',
				green: '#4AB22E',
				greenComplete: '#04A923',
			},
		},
		card: {
			border: '#E5E5E5',
			promoColor: '#BA53FF',
		},
	},
	background: {
		body: '#FBFBFB',
		tab: '#FFFFFF',
		info: '#C8EAFF',
	},
	infoPart: {
		background: '#C8EAFF',
		borderBlue: '#046CAE',
	},
	font: {
		fxs: '12px',
		fs: '13px',
		fm: '14px',
		fl: '16px',
		fxl: '18px',
		fxxl: '20px',
		fxll: '22px',
		fxxxl: '24px',
		fxxxxl: '36px',
	},
	margin: {
		mt: '10px',
	},
	weight: {
		bold: '900',
	},
	rafters: {
		darkBlue: '#024A78',
		lightBlue: '#0885D5',
		lightGrey: '#E5E5E5',
		fontGrey: '#A1A1A1',
	},
	bankDetail: {
		infoBorder: '#C2DFF2',
		infoBackground: '#D7E9F5',
		border: '#E5E5E5',
		white: '#FFFFFF',
	},
}

export default theme
